import { convertObjToQueryString } from "../../utils/helpers";

export const getRingUserData = (userId: string) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_RING_SERVICE_URL}/v1/coach/userProfile`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getRingUserFromUserList = (data: { [key: string]: any }) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_RING_SERVICE_URL}/v1/ring/fetchRingUsers`,
    data,
  };
};

export const getRingUserActivityData = (
  queryObj: { [key: string]: any },
  userId: string
) => {
  const query = convertObjToQueryString(queryObj);
  return {
    method: "GET",
    url: `${process.env.REACT_APP_RING_SERVICE_URL}/v1/coach/detail-page/activity${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getRingUserCalorieData = (
  queryObj: { [key: string]: any },
  userId: string
) => {
  const query = convertObjToQueryString(queryObj);
  return {
    method: "GET",
    url: `${process.env.REACT_APP_RING_SERVICE_URL}/v1/coach/detail-page/calorieBalance${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getRingUserSleepData = (
  queryObj: { [key: string]: any },
  userId: string
) => {
  const query = convertObjToQueryString(queryObj);
  return {
    method: "GET",
    url: `${process.env.REACT_APP_RING_SERVICE_URL}/v1/coach/detail-page/sleep${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getRingUserStressData = (
  queryObj: { [key: string]: any },
  userId: string
) => {
  const query = convertObjToQueryString(queryObj);
  return {
    method: "GET",
    url: `${process.env.REACT_APP_RING_SERVICE_URL}/v1/coach/detail-page/stress${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getRingUserHeartRateData = (
  queryObj: { [key: string]: any },
  userId: string
) => {
  const query = convertObjToQueryString(queryObj);
  return {
    method: "GET",
    url: `${process.env.REACT_APP_RING_SERVICE_URL}/v1/coach/detail-page/heart-rate${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getRingUserVO2MaxData = (
  queryObj: { [key: string]: any },
  userId: string
) => {
  const query = convertObjToQueryString(queryObj);
  return {
    method: "GET",
    url: `${process.env.REACT_APP_RING_SERVICE_URL}/v1/coach/detail-page/vo2Max${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};
